var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 11.2C8.69279 11.2 11.2 8.69279 11.2 5.6C11.2 2.50721 8.69279 0 5.6 0C2.50721 0 0 2.50721 0 5.6C0 8.69279 2.50721 11.2 5.6 11.2Z",
    fill: "#00983F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27785 2.96433C8.44477 2.76795 8.73928 2.74407 8.93566 2.91099C9.13203 3.07791 9.15591 3.37242 8.98899 3.5688L5.02233 8.23546C4.85279 8.43492 4.55237 8.45594 4.35672 8.28202L2.25672 6.41535C2.06409 6.24412 2.04674 5.94916 2.21796 5.75653C2.38919 5.56389 2.68416 5.54654 2.87679 5.71777L4.62019 7.26746L8.27785 2.96433Z",
    fill: "#F8F9FA"
  })));
};
export default SvgVerified;